import type { TypeOrArray } from '../../../../common-interfaces';
import { isArrayDropDownResult, isDropDownResult } from '../../../../fields/drop-down/drop-down-common';
import type { JsonDataItem } from '../../../../generic-types';
import type { VisibilityCondition } from '../../visibility-condition.interfaces';
import type { ITargetValueConverter, ValueConverterReturnType } from './i-target-value-converter';

export class StringTargetValueConverter implements ITargetValueConverter {
  convert(condition: VisibilityCondition, data: JsonDataItem): TypeOrArray<ValueConverterReturnType> {
    if (condition.sourceFieldId && data?.[condition.sourceFieldId]) {
      const dataItem = data[condition.sourceFieldId];
      if (Array.isArray(dataItem)) {
        if (condition.targetValueType === 'STRING' && Array.isArray(condition.targetValue)) {
          if (isArrayDropDownResult(dataItem)) {
            const dataItemTexts = dataItem.map((item) => item.text);
            return [
              dataItemTexts,
              condition.targetValue,
              condition.negation || false,
              condition.filterOperator || 'EQUALS',
            ];
          }

          return [dataItem, condition.targetValue, condition.negation || false, condition.filterOperator || 'EQUALS'];
        } else if (condition.targetValueType === 'ENTITY_ID' && Array.isArray(condition.targetValueId)) {
          if (isArrayDropDownResult(dataItem)) {
            const dataItemValues = dataItem.map((item) => Number(item.value));
            return [
              dataItemValues,
              condition.targetValueId,
              condition.negation || false,
              condition.filterOperator || 'EQUALS',
            ];
          }

          return [dataItem, condition.targetValueId, condition.negation || false, condition.filterOperator || 'EQUALS'];
        } else {
          const wrapperArray: Array<ValueConverterReturnType> = [];
          for (let i = 0, length = dataItem.length; i < length; i++) {
            const item = dataItem[i];
            wrapperArray.push([
              isDropDownResult(item) ? item.value : item,
              condition.targetValueId,
              condition.negation || false,
              condition.filterOperator || 'EQUALS',
            ]);
          }

          return wrapperArray.length > 0
            ? wrapperArray
            : [undefined, condition.targetValueId, condition.negation || false, condition.filterOperator || 'EQUALS'];
        }
      } else if (isDropDownResult(dataItem)) {
        if (condition.targetValueType === 'STRING') {
          return [
            dataItem.text,
            String(condition.targetValue),
            condition.negation || false,
            condition.filterOperator || 'EQUALS',
          ];
        } else if (condition.targetValueType === 'ENTITY_ID') {
          return [
            Number(dataItem.value),
            condition.targetValueId,
            condition.negation || false,
            condition.filterOperator || 'EQUALS',
          ];
        } else {
          return [
            undefined,
            condition.targetValueId,
            condition.negation || false,
            condition.filterOperator || 'EQUALS',
          ];
        }
      } else {
        return [
          String(dataItem),
          condition.targetValue !== null && condition.targetValue !== undefined
            ? String(condition.targetValue)
            : condition.targetValueId,
          condition.negation || false,
          condition.filterOperator || 'EQUALS',
        ];
      }
    }

    // if there is no data then we still need to send back the other pieces so the condition evaluates successfully
    return [undefined, condition.targetValueId, condition.negation || false, condition.filterOperator || 'EQUALS'];
  }
}
